import React from 'react'
import CenteredLoadingSpinner from '../../common/CenteredLoadingSpinner'

export default function MemoriesTabSkeleton(): JSX.Element {
  return <CenteredLoadingSpinner />
}
